module.exports = __webpack_public_path__ + "img/bni.a9cfb698.png";